//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

// 成本明细--原辅料耗用明细
const costDetailsList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/productionCenter/costDetails/list.vue')),
    'costDetails'
  );
// 新增成本明细
const costAdd = (r) =>
  require.ensure([], () => r(require('@/pages/productionCenter/costDetails/add.vue')), 'costAdd');
// 成本明细详情
const costDetails = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/productionCenter/costDetails/details.vue')),
    'costDetails'
  );

const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'costDetailsList',
      name: 'costDetailsList',
      component: costDetailsList,
      meta: {
        keepAlive: true,
        title: '原辅料耗用明细',
      },
    },
    {
      path: 'costAdd',
      name: 'costAdd',
      component: costAdd,
      meta: {
        keepAlive: true,
        title: '新增原辅料耗用',
      },
    },
    {
      path: 'costDetails',
      name: 'costDetails',
      component: costDetails,
      meta: {
        keepAlive: true,
        title: '原辅料耗用明细详情',
      },
    },
  ],
};
export default productionRouter;
